import { render } from "./Agent.vue?vue&type=template&id=37057d1a&scoped=true"
import script from "./Agent.vue?vue&type=script&lang=js"
export * from "./Agent.vue?vue&type=script&lang=js"

import "./Agent.vue?vue&type=style&index=0&id=37057d1a&scoped=true&lang=css"

import exportComponent from "/var/www/water.jatriweb.team/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37057d1a"]])

export default __exports__